import React, { useState, useEffect } from 'react';
import {useParams} from "react-router-dom";
import { Col } from 'antd';
import TabTableDashboardLayout from 'components/layouts/tab/table';
import AccessCheckbox from "core/ui-kit/accessCheckbox";
import Form from "core/ui-kit/form";
import showSuccess from 'core/helpers/common/showSuccess';
import {useTranslation} from "core/hooks/useTranslation";
import {isFormChanged} from "utils/form";
import {FIELDS, initialFormValues} from "./constants";
import affiliateManagerService from "core/services/apiServices/affiliateManagerService";

const initialState = {
    isSaving: false,
    isFormTouched: false,
    isLoading: false,
    formInitialValues: null,
};

const Accesses = () => {
    const [state, setState] = useState(initialState);
    const searchParams = useParams();

    const [formInstance] = Form.useForm();

    const { setFieldsValue, getFieldsValue } = formInstance;

    const { t } = useTranslation();

    const getAffiliateManagerAccesses = () => {
        affiliateManagerService.getAffiliateManagerAccesses({ userNameOrId: searchParams.id })
            .then((res) => {
                setFieldsValue(res);
                setState({ ...initialState, formInitialValues: res });
            });
    }

    const saveAffiliateManagerAccesses = (values) => {
        setState((prev) => ({ ...prev, isSaving: true }));
        affiliateManagerService.saveAffiliateManagerAccesses({
            userNameOrId: searchParams.id,
            ...values,
        }).then((response) => {
            showSuccess(response?.message);
            getAffiliateManagerAccesses();
        });
    }

    const getInitialData = () => {
        setState((prev) => ({ ...prev, isLoading: true }));
        getAffiliateManagerAccesses();
    }

    const handleSave = () => {
        formInstance.submit();
    }

    const onValuesChange = () => {
        const currentValues = getFieldsValue();
        const isValuesChanged = isFormChanged(currentValues, state.formInitialValues);
        setState((prev) => ({ ...prev, isFormTouched: isValuesChanged }));
    }

    useEffect(getInitialData, []);

    return (
        <TabTableDashboardLayout
            buttons={
                [
                    {
                        type: "primary",
                        onClick: handleSave,
                        text: t("backoffice.common.save"),
                        loading: state.isSaving,
                        disabled: !state.isFormTouched,
                        enabled: true
                    }
                ]
            }
        >
            <Form
                form={formInstance}
                initialValues={initialFormValues}
                onFinish={saveAffiliateManagerAccesses}
                onValuesChange={onValuesChange}
            >
                <div className="rt--user-management-accesses">
                    <h4 className="rt--corporate-color rt--font-bold rt--font-biger rt--mb-16">{t('backoffice.users.campaignManagement')}</h4>
                    <Col xs={24} sm={24} xl={12} xxl={12}>
                        <Form.Item
                            name={FIELDS.CAMPAIGN_MANAGEMENT}
                            valuePropName='checked'
                        >
                            <AccessCheckbox
                                title={t('backoffice.users.manage')}
                                description={t('backoffice.users.campaignManagementDescription')}
                            />
                        </Form.Item>
                    </Col>
                </div>
            </Form>
        </TabTableDashboardLayout>
    )
}

export default Accesses;
